import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundtoshirdicabbooking() {



  const cardData =
  {
    keyword: 'Daund to Shirdi Cab Booking',
    heading: 'Sanavi Travels: Daund to Shirdi Cab Booking',
    headingDescription: 'Sanavi Travels offers reliable Daund to Shirdi Cab Booking, providing safe, comfortable, and hassle-free transportation for pilgrims, families, and tourists traveling from Daund to the holy town of Shirdi. Our fleet of well-maintained sedans, SUVs, and luxury cabs ensures spacious seating, air-conditioning, and ample luggage space for a smooth and peaceful journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient doorstep pickup in Daund and nearby areas, covering major spiritual attractions such as Sai Baba Temple, Dwarkamai, Chavadi, Lendi Baug, and Shani Shingnapur. Choose Sanavi Travels for trusted Daund to Shirdi cab booking services, delivering comfort, safety, and a spiritually fulfilling travel experience.',

    top: 'Top Places to Visit in Shirdi with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "Shirdi Sai Baba Temple is one of India’s most revered pilgrimage destinations, dedicated to Sai Baba. Millions of devotees from all faiths visit the temple seeking blessings, faith, and inner peace. The well-organized darshan system and sacred aartis create a deeply spiritual experience."
  },
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Samadhi Mandir is the heart of Shirdi, housing the tomb of Sai Baba. Devotees experience profound devotion and calm while offering prayers here, making it the most important shrine within the temple complex."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the sacred mosque where Sai Baba lived and performed miracles. The holy dhuni (sacred fire) burns continuously here, symbolizing faith, protection, and spiritual strength."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is a historic place where Sai Baba used to rest on alternate nights. Even today, ceremonial processions are carried out on Thursdays and festival days, preserving age-old traditions."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a tranquil garden where Sai Baba spent time in meditation. It features the sacred Nanda Deep lamp, which has been continuously lit and is believed to bring peace and healing to devotees."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is historically significant as the place where Sai Baba was first welcomed to Shirdi. It marks the beginning of Sai Baba’s spiritual journey in the town."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a devotional theme park that recreates scenes from Sai Baba’s life using statues and traditional settings. It helps visitors understand Sai Baba’s teachings in an engaging and visual way."
  },
  {
    "title": "Abdul Baba’s Cottage",
    "description": "Abdul Baba’s Cottage honors one of Sai Baba’s closest disciples. The site reflects deep devotion and the spiritual bond between Sai Baba and his followers."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Located near Shirdi, Shani Shingnapur is a famous temple of Lord Shani known for its open-door village tradition. Many devotees visit Shani Shingnapur along with Shirdi for spiritual balance and blessings."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park is a popular recreational attraction near Shirdi, offering water rides, wave pools, and family entertainment. It provides a refreshing leisure option alongside spiritual travel."
  }
]
,



"services": [
  {
    "name": "Daund to Shirdi Cab Booking",
    "description": "Daund to Shirdi Cab Booking offers a reliable and comfortable travel solution for devotees and travelers planning a visit to Shirdi for Sai Baba darshan. Well-maintained, air-conditioned cabs with clean interiors, comfortable seating, and ample luggage space ensure a relaxed journey. Experienced chauffeurs manage highway driving, traffic conditions, and temple-route navigation efficiently to ensure timely pickups and safe arrivals. Ideal for families, senior citizens, and pilgrims, this service supports flexible travel schedules and smooth end-to-end journey planning."
  },
  {
    "name": "Online Cab Booking Daund Shirdi",
    "description": "Online Cab Booking Daund Shirdi allows customers to easily book cabs from Daund to Shirdi through a quick and convenient booking process. Travelers can select cab type, pickup location, travel date, and trip preference with fast confirmation. Fully air-conditioned vehicles with professional chauffeurs ensure safe, organized, and hassle-free travel, making this option ideal for pilgrims, families, and tourists."
  },
  {
    "name": "AC Cab Daund to Shirdi",
    "description": "AC Cab Daund to Shirdi ensures a cool and comfortable ride throughout the journey, especially during long-distance travel and warm weather. Fully air-conditioned cabs with smooth suspension, spacious seating, and clean interiors reduce travel fatigue. Skilled chauffeurs ensure safe driving and efficient route planning, making this service ideal for devotees, families, and senior citizens."
  },
  {
    "name": "Affordable Cab Booking Shirdi",
    "description": "Affordable Cab Booking Shirdi provides budget-friendly cab options without compromising on comfort or safety. Clean, air-conditioned cabs with experienced drivers ensure a smooth and economical journey from Daund to Shirdi. Ideal for cost-conscious travelers, families, and pilgrims, this service balances affordability, reliability, and convenience."
  },
  {
    "name": "Chauffeur Driven Cab Shirdi",
    "description": "Chauffeur Driven Cab Shirdi offers a stress-free travel experience with professional drivers handling navigation, traffic, and schedules. Comfortable AC cabs allow passengers to relax and focus on their pilgrimage or travel plans. Especially suitable for elderly devotees and families, this service emphasizes safety, courtesy, and punctual service."
  },
  {
    "name": "Best Cab Service Daund",
    "description": "Best Cab Service Daund delivers high-quality cab services with well-maintained vehicles and trained chauffeurs for Daund to Shirdi travel. Fully air-conditioned cabs ensure comfort during the entire journey, while professional drivers ensure timely pickups and safe arrivals. Ideal for families, tourists, and regular pilgrims, this service focuses on reliability and customer satisfaction."
  },
  {
    "name": "One Way Cab Shirdi",
    "description": "One Way Cab Shirdi is a cost-effective solution for travelers who require a single journey from Daund to Shirdi. Comfortable air-conditioned cabs with experienced chauffeurs ensure a smooth, safe, and timely ride without return charges. Ideal for pilgrims, business travelers, and tourists seeking flexible one-way travel options."
  },
  {
    "name": "Round Trip Cab Shirdi",
    "description": "Round Trip Cab Shirdi is perfect for travelers planning to return to Daund after completing Shirdi darshan. Air-conditioned vehicles with professional drivers ensure a comfortable and safe round journey. Suitable for family visits, short pilgrimages, and planned temple tours, this service offers flexibility, convenience, and better value."
  },
  {
    "name": "Family Cab Booking",
    "description": "Family Cab Booking is designed to make family travel safe, comfortable, and convenient for Daund to Shirdi journeys. Spacious air-conditioned cabs with ample luggage space accommodate all family members comfortably. Professional chauffeurs ensure smooth driving, flexible travel plans, and a relaxed experience, making it ideal for family darshan trips."
  },
  {
    "name": "Tourist Cab Shirdi",
    "description": "Tourist Cab Shirdi provides organized cab services for tourists visiting Shirdi and nearby attractions. Comfortable AC cabs with knowledgeable chauffeurs ensure a pleasant and informative travel experience. Perfect for families, couples, and groups planning temple visits and sightseeing trips."
  },
  {
    "name": "Railway Station Pickup Daund",
    "description": "Railway Station Pickup Daund offers timely and hassle-free pickups from Daund railway station for Shirdi-bound travelers. Drivers track train arrivals to ensure punctual pickups and smooth onward journeys. Comfortable air-conditioned cabs make this service ideal for pilgrims and tourists arriving by train."
  },
  {
    "name": "Shirdi Darshan Cab",
    "description": "Shirdi Darshan Cab is specially designed for devotees planning Sai Baba darshan. The service ensures timely departures, convenient temple-area drop-offs, and comfortable return journeys. Experienced drivers help manage darshan schedules smoothly, creating a peaceful and devotional travel experience."
  },
  {
    "name": "Outstation Cab Daund",
    "description": "Outstation Cab Daund provides reliable long-distance cab services from Daund to Shirdi and other destinations. Well-maintained, air-conditioned vehicles with professional chauffeurs ensure safe highway driving, comfortable seating, and timely arrivals. Suitable for pilgrimages, family trips, and extended travel plans."
  },
  {
    "name": "Fast Cab Booking Shirdi",
    "description": "Fast Cab Booking Shirdi focuses on quick confirmations and prompt service for Daund to Shirdi travel. Efficient booking processes, readily available cabs, and professional drivers ensure minimal waiting time and smooth travel. Ideal for last-minute plans, urgent darshan trips, and flexible travel needs."
  },
  {
    "name": "Shirdi Travel Taxi",
    "description": "Shirdi Travel Taxi offers dedicated taxi solutions for pilgrims and tourists traveling between Daund and Shirdi. Comfortable AC cabs with trained chauffeurs ensure smooth travel for darshan, sightseeing, and return trips. This service emphasizes comfort, safety, flexibility, and a calm travel experience."
  }
],
"tableData": [
  ["Daund to Shirdi Cab Booking", "Online Cab Booking Daund Shirdi"],
  ["AC Cab Daund to Shirdi", "Affordable Cab Booking Shirdi"],
  ["Chauffeur Driven Cab Shirdi", "Best Cab Service Daund"],
  ["One Way Cab Shirdi", "Round Trip Cab Shirdi"],
  ["Family Cab Booking", "Tourist Cab Shirdi"],
  ["Railway Station Pickup Daund", "Shirdi Darshan Cab"],
  ["Outstation Cab Daund", "Fast Cab Booking Shirdi"],
  ["Shirdi Travel Taxi", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Daund to Shirdi Cab Booking with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab booking services from Daund to Shirdi, ideal for devotees, family trips, pilgrimages, and outstation travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Cabs",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to ensure a smooth and peaceful journey from Daund to Shirdi."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and well-versed with the Daund to Shirdi route, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Daund to Shirdi cab bookings, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with cab bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Cab Booking Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized cab packages based on your Daund to Shirdi travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Daund to Shirdi cab booking."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab booking from Daund to Shirdi?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable cab booking services from Daund to Shirdi.'
  },
  {
    question: 'How can I book a Daund to Shirdi cab?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available for Daund to Shirdi travel?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for the Daund to Shirdi journey.'
  },
  {
    question: 'Are drivers experienced on the Daund to Shirdi route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Daund to Shirdi route.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup location in Daund and drop-off in Shirdi.'
  },
  {
    question: 'Is the Daund to Shirdi cab service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services to suit your travel schedule.'
  },
  {
    question: 'Are vehicles sanitized before trips?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available for cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Daund to Shirdi trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sanjay Kulkarni',
    feedback: 'Booked a cab from Daund to Shirdi with Sanavi Travels. Comfortable journey and on-time service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Anjali Deshmukh',
    feedback: 'Very smooth cab booking experience. Clean vehicle and polite driver. Highly recommended.',
    rating: 5
  }
];













































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund to Shirdi Cab Booking - Sanavi Travels",
  "description": "Book AC and chauffeur-driven cabs from Daund to Shirdi with Sanavi Travels. Ideal for Sai Baba darshan, family trips, group travel, railway station pickups, one-way and round trips, and comfortable, reliable cab service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Daund to Shirdi Cab Booking | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and chauffeur-driven cabs from Daund to Shirdi with Sanavi Travels. Perfect for Sai Baba darshan, family trips, group travel, railway pickups, one-way and round trips, and safe, comfortable travel."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/89.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundtoshirdicabbooking;